import { LoadingWrapper } from "@vapor/react-contrib-tax-compliance";
import { Box } from "@vapor/react-material";
import { useMemo, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
).toString();

interface PdfPreviewerProps {
    file: Uint8Array;
}

export const PdfPreviewer = ({ file }: PdfPreviewerProps) => {
    const [numPages, setNumPages] = useState<number>();

    // Wrap the bytes in a Blob rather than passing `{ data: Uint8Array }`:
    // pdf.js transfers (detaches) the ArrayBuffer of a typed array it receives,
    // so a memoized typed array would be left empty and any reload would fail
    // with "ArrayBuffer is detached". A Blob is immutable and re-readable —
    // pdf.js reads its own copy and never touches our source. Memoized on `file`
    // so react-pdf keeps a stable reference and doesn't reload on every render.
    // Build from a fresh copy's `.buffer` (a plain ArrayBuffer, always a valid
    // BlobPart) — same idiom as useDownloadFile — so the type stays correct even
    // under the stricter DOM lib that excludes SharedArrayBuffer-backed views.
    const pdfData = useMemo(
        () => new Blob([new Uint8Array(file).buffer]),
        [file],
    );

    function onDocumentLoadSuccess({
        numPages: nextNumPages,
    }: {
        numPages: number;
    }): void {
        setNumPages(nextNumPages);
    }

    return (
        <Box>
            <Document
                file={pdfData}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<LoadingWrapper loading={true} variant="spinner" />}
            >
                {Array.from(new Array(numPages), (_el, index) => (
                    <Page
                        key={index}
                        pageNumber={index + 1}
                        loading={
                            <LoadingWrapper loading={true} variant="spinner" />
                        }
                        width={700}
                    />
                ))}
            </Document>
        </Box>
    );
};
